import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Chat/JsonRenderComponents/signalCards/AssetSentimentRatioCard";
/**
 * ⑥ 技术情绪多空比卡。 Figma：94103:23505
 */

import { OspIcons } from "@ospweb/sdk-ui/src/Icon/OspIcons";
import { SignalCardShell } from "./SignalCardShell";
import type { SignalCardAssetProps } from "./types";

const I18n = I18nUtil.createScoped(Translations);

export interface AssetSentimentRatioCardProps extends SignalCardAssetProps {
  bullishCount: number;
  bearishCount: number;
}

export const AssetSentimentRatioCard: React.FC<
  AssetSentimentRatioCardProps
> = ({ bullishCount, bearishCount, ...asset }) => {
  return (
    <SignalCardShell {...asset}>
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1">
            <OspIcons
              name="trending-up"
              size={16}
              className="text-content_accent1_primary"
            />
            <span className="body_medium_m text-content_accent1_primary">
              {I18n.t("Bullish")}
              {bullishCount}
            </span>
          </div>
          <div className="flex items-center gap-1">
            <OspIcons
              name="trending-down"
              size={16}
              className="text-content_accent2_primary"
            />
            <span className="body_medium_m text-content_accent2_primary">
              {I18n.t("Bearish")}
              {bearishCount}
            </span>
          </div>
        </div>
        <div className="flex w-full gap-1">
          <div
            className="h-3 min-w-0 flex-1 rounded-1 bg-background_accent1_overlay70"
            style={{ flexGrow: Math.max(bullishCount, 1) }}
          />
          <div
            className="h-3 min-w-0 rounded-1 bg-background_accent2_overlay70"
            style={{
              flexGrow: Math.max(bearishCount, 1),
              flexBasis: bearishCount === 0 ? "57px" : undefined,
            }}
          />
        </div>
      </div>
    </SignalCardShell>
  );
};
